import React from 'react'
import AddEditCampaign from '../../features/emailManagement/component/AddEditCampaign'

function EmailCampaign() {
    return (
        <AddEditCampaign ></AddEditCampaign>
    )
}

export default EmailCampaign